<template>
    <UserWrapper :extraWidth="false" :showTitleContainer="false">
            <div class="contact-detail mt-4">
                <div class="desktop-view">
                    <Loader v-if="loading" />
                    
                    <!-- Empty message when no contacts -->
                    <div v-if="showEmptyMessage && !loading" class="empty-message">
                        <p>企業からメッセージが届くとここに表示されます</p>
                    </div>

                    <div v-if="showEmptyMessage && !loading" class="scout-promo-card">
                        <svg class="scout-promo-icon" width="32" height="32" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.0027 10.9414C16.7257 10.9414 14.5896 11.8285 12.9843 13.4335C11.3787 15.0391 10.4922 17.1755 10.4922 19.4458C10.4922 21.7228 11.3788 23.859 12.9843 25.4645L13.0109 25.4914C13.2058 25.6789 13.4206 25.8674 13.6558 26.0553L13.9581 29.3734C13.7902 29.4546 13.6494 29.5754 13.5485 29.73C13.4143 29.9448 13.367 30.1999 13.4276 30.4487L13.4746 30.6838C13.5552 31.0332 13.817 31.288 14.1394 31.3825L14.1933 31.9534L14.1463 31.9664C13.6358 32.0809 13.3134 32.5912 13.4276 33.1023L13.4746 33.3366C13.5352 33.5856 13.6828 33.7938 13.8979 33.935C14.0457 34.0289 14.2136 34.0758 14.3882 34.0825L14.5493 35.8693H15.8458C16.363 37.1525 17.5992 37.999 19.0027 37.999C20.4068 37.999 21.6493 37.1594 22.1602 35.8693H23.4497L23.8058 32.0001L23.8594 31.9867C24.3702 31.8725 24.6925 31.362 24.5781 30.8517L24.5247 30.6166C24.4575 30.3212 24.2557 30.0861 23.9872 29.9651L24.0542 29.2664C24.4505 29.0782 24.6792 28.6416 24.5781 28.1984L24.5247 27.963C24.4774 27.7684 24.3702 27.5936 24.2154 27.4593L24.3499 26.0552C24.5781 25.8674 24.8002 25.6726 25.015 25.4644C26.6203 23.8588 27.5071 21.7227 27.5071 19.4457C27.5071 17.1753 26.6202 15.039 25.015 13.4334C23.4094 11.8285 21.2733 10.9414 19.0027 10.9414ZM22.019 27.4603L21.9787 27.9027L16.8086 29.063L16.1416 29.2111L15.9868 27.4594H21.5233L22.019 27.4603ZM16.383 31.811L16.2755 30.6839L21.8378 29.441L21.7299 30.61L16.9736 31.6798L16.383 31.811ZM21.1661 25.4842C21.1661 25.4842 21.1661 25.8202 21.1661 26.2638H16.8399C16.8399 25.8202 16.8399 25.4842 16.8399 25.4842C16.3427 25.263 15.3019 24.6582 14.536 23.9125C13.394 22.7706 12.6819 21.192 12.6819 19.4458C12.6819 17.706 13.394 16.1274 14.536 14.9785C15.6779 13.8368 17.2566 13.1312 19.0027 13.1312C20.7428 13.1312 22.3211 13.8368 23.47 14.9785C24.6117 16.1274 25.3171 17.706 25.3171 19.4458C25.3171 21.192 24.6117 22.7706 23.47 23.9125C22.6974 24.6582 21.6563 25.263 21.1661 25.4842ZM20.2119 33.6796V34.6337C20.192 35.2852 19.6611 35.8087 19.0027 35.8087C18.331 35.8087 17.7871 35.2718 17.7871 34.6V33.6796H16.5512L16.5176 33.283L21.5891 32.1482L21.4482 33.6796H20.2119Z" fill="#2F2E41"/>
                            <path d="M20.5868 19.1586C20.4456 19.1116 20.2978 19.1586 20.2105 19.2795C20.1569 19.3535 20.1029 19.4404 20.0426 19.5483C19.8278 19.904 19.532 20.4015 19.0888 20.4015C18.5849 20.4015 18.1413 19.7701 17.9132 19.4341C17.8662 19.3734 17.8326 19.3198 17.7993 19.2795C17.7117 19.1586 17.5638 19.1117 17.423 19.1586C17.2684 19.2053 17.1675 19.3671 17.1809 19.5414L18.1483 24.5662L18.6186 24.492L18.6318 24.4856H18.6385L18.1885 22.1477L17.9804 21.0536L17.8125 20.1146C18.1138 20.4796 18.5391 20.8579 19.0888 20.8579C19.5118 20.8579 19.8278 20.6297 20.0626 20.3613C20.1 20.3239 20.1299 20.2816 20.1621 20.2413C20.1812 20.2209 20.2009 20.2013 20.2212 20.1824L19.5588 24.3781L19.5387 24.4856V24.492L20.0292 24.5595L20.8283 19.5617V19.5414C20.8419 19.367 20.7414 19.2053 20.5868 19.1586Z" fill="#2F2E41"/>
                            <path d="M19.0051 6.14191C19.4116 6.1428 19.7485 5.82885 19.7769 5.42354L20.0882 0.824282C20.1189 0.380156 19.767 0.00297674 19.3223 0.00208612L18.7263 7.99222e-06C18.281 -0.00199591 17.9276 0.373106 17.9546 0.817899L18.239 5.41887C18.2638 5.82418 18.599 6.14072 19.0051 6.14191Z" fill="#2F2E41"/>
                            <path d="M11.4626 9.23796C11.7511 8.95185 11.7676 8.49088 11.5003 8.18561L8.46866 4.7124C8.44172 4.68138 8.40513 4.66713 8.37441 4.6413C8.35207 4.62245 8.32913 4.60508 8.30509 4.58912C8.23547 4.54303 8.16392 4.5106 8.08562 4.48974C8.06529 4.48395 8.04502 4.47868 8.02409 4.47497C7.78556 4.43148 7.5318 4.48685 7.34514 4.6721L6.92247 5.09247C6.60704 5.40612 6.6221 5.92165 6.95527 6.21652L10.4102 9.26906C10.714 9.53773 11.1751 9.52415 11.4626 9.23796Z" fill="#2F2E41"/>
                            <path d="M31.0866 5.16492L30.6668 4.74195C30.4807 4.55499 30.2264 4.49814 29.9867 4.54074C29.9658 4.54453 29.9455 4.5498 29.9252 4.55529C29.8472 4.57585 29.7759 4.60769 29.7066 4.65326C29.6822 4.66892 29.6596 4.68606 29.637 4.70454C29.6065 4.73007 29.57 4.74395 29.5427 4.77475L26.4902 8.22964C26.2211 8.53379 26.2344 8.99476 26.5209 9.28295C26.807 9.57077 27.2677 9.5871 27.5738 9.31976L31.047 6.28867C31.3826 5.99521 31.4009 5.48057 31.0866 5.16492Z" fill="#2F2E41"/>
                        </svg>
                        <p class="scout-promo-title">スカウトを受け取りやすくするために</p>
                        <p class="scout-promo-text">
                            気になる求人に「スカウト希望」すると<br />
                            スカウトが届きやすくなります
                        </p>
                        <button type="button" class="scout-promo-button" @click="goToJobListings">
                            求人を見る
                        </button>
                    </div>

                    <!-- Contact cards list only shown when there are contacts -->
                    <div v-if="!showEmptyMessage && !loading" class="contact-list-container">
                        <ContactList v-for="contact in contacts" :key="contact._id" :contact="contact" :profile="profile"/>
                    </div>
                    
                    <!-- Pagination only shown when there are contacts and multiple pages -->
                    <div class="pagination-area" v-if="totalPages > 1 && !showEmptyMessage">
                        <Pagination :total-page="totalPages" :callback="changePage" />
                    </div>
                </div>
            </div>
        <template v-slot:footer>
            <Footer/>
        </template>
    </UserWrapper>
</template>

<script>
import Api from '@/config/api';
import moment from 'moment';
// import ProfileHeader from "@/components/header.vue";
import UserWrapper from '../UserWrapper.vue';
import Pagination from '../Pagination.vue';
import Loader from '../Loader.vue';
import Footer from '../Footer.vue';
import ContactList from './ContactList.vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
export default {
    name: 'TopContacts',
    components: { UserWrapper, Pagination, Loader, Footer, ContactList },
    data(){
        return {
            loading: false,
            // contacts: [],
        }
    },
    computed: {
        ...mapGetters({ 
            contacts:'getContacts', 
            totalContacts: 'getTotalContacts',
            profile: 'getProfile'
        }),
        ...mapState({
            page: ({ contact }) => contact.currentPage,
        }),
        allContactsCount() {
            return this.contacts.length;
        },
        totalPages(){
            return this.totalContacts ? Math.ceil(this.totalContacts/5) : 0;
        },
        showEmptyMessage() {
            console.log(this.contacts.length)
            return this.contacts.length === 0;
        },
    },
    methods: {
        ...mapActions(['loadContacts', 'setProfile']),
        ...mapMutations(['setPage']),
        changePage(page){
            this.setPage(page);
        },
        goToJobListings() {
            this.$router.push('/job-listings');
        },
        async loadTopContacts(){
            try {
                await this.$auth.getToken();
                const contacts = await this.axios({
                    method: 'get',
                    url: Api.url(`${Api.endpoints.allMessages}?page=${page}`),
                });
                // console.log(contacts);
                this.contacts = contacts.data.data;
            } catch (err) {
                console.log(err);
            }
        }
    },
    async created(){
        this.loading = true;
        await this.setProfile();
        this.setPage(1);
        await this.loadContacts(1);
        this.loading = false;
    },
    watch: {
        page: function(currentPage) {
            this.loadContacts(currentPage);
        }
    }
}
</script>

<style scoped>
.contact-detail {
    width: 100%;
}

.contact-list-container {
    display: flex;
    flex-direction: column;
    gap: 0;
}

.empty-message {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 47px;
    padding: 28px 20px;
    margin: 20px auto 0;
    border-radius: 10px;
    color: #000000;
    font-size: 16px;
    text-align: center;
    max-width: 480px;
}

.empty-message p {
    margin: 0;
    white-space: nowrap;
}

.scout-promo-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: 480px;
    margin: 24px auto 0;
    padding: 32px 24px;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
}

.scout-promo-icon {
    margin-bottom: 12px;
}

.scout-promo-title {
    font-size: 18px;
    font-weight: bold;
    color: #3c3c3c;
    margin: 0 0 12px;
}

.scout-promo-text {
    font-size: 14px;
    color: #3c3c3c;
    margin: 0 0 20px;
}

.scout-promo-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 338px;
    height: 45px;
    max-width: 100%;
    background: #006c6b;
    border: none;
    border-radius: 4.62px;
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    padding: 0;
    cursor: pointer;
}

.scout-promo-button:hover {
    background: #065a59;
}

@media (max-width: 768px) {
    .contact-detail {
        margin-top: 0 !important;
    }

    .empty-message {
        height: auto;
        margin: 0 auto;
        max-width: 100%;
        padding: 0 20px;
    }

    .empty-message p {
        font-family: Roboto, sans-serif;
        font-weight: 400;
        font-size: 10px;
        line-height: 100%;
        letter-spacing: 0;
    }

    .scout-promo-card {
        max-width: 300px;
        padding: 24px 16px;
    }

    .scout-promo-title {
        font-size: 14px;
    }

    .scout-promo-text {
        font-size: 12px;
    }

    .scout-promo-button {
        width: 216.72px;
        height: 32.52px;
        border-radius: 2.96px;
        font-size: 14px;
    }
}

.pagination-area {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    background-color: #E7F6F6;
    padding: 20px 0;
}

@media(max-width: 550px) {
    .contact-detail {
        padding: 0px !important;
    }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* CSS rules for iPads in portrait mode */
  .contact-detail {
    padding: 0px;
  }
}

</style>